import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgMultipleDevices(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="5 10 50 39"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        stroke="#fff"
        strokeWidth={0.2}
        d="M9.75 12.08H43.5a2.153 2.153 0 0 1 2.15 2.15v10.6h4.6a2.153 2.153 0 0 1 2.15 2.15v18l-.01.212a2.153 2.153 0 0 1-2.14 1.938h-10.5a2.153 2.153 0 0 1-2.15-2.15v-5.537h-8.825v4.887H34.4v2.8H20.35v-2.8h5.625v-4.887H9.75a2.153 2.153 0 0 1-2.15-2.15V14.23a2.154 2.154 0 0 1 2.15-2.15ZM40.4 44.33h9.2v-16.7h-9.2zm-30-7.688h27.2V26.98a2.153 2.153 0 0 1 2.15-2.15h3.1v-9.95H10.4z"
      />
      <rect
        width={14.5}
        height={0.5}
        x={12.25}
        y={16.25}
        fill={props.secondaryColor}
        stroke={props.secondaryColor}
        strokeWidth={0.5}
        rx={0.25}
      />
      <rect
        width={6.5}
        height={0.5}
        x={12.75}
        y={19.25}
        fill={props.secondaryColor}
        stroke={props.secondaryColor}
        strokeWidth={0.5}
        rx={0.25}
        transform="rotate(90 12.75 19.25)"
      />
    </svg>
  );
}
export default SvgMultipleDevices;
